// extracted by mini-css-extract-plugin
export default {"header":"home-header_header__WFr5T","wrapper":"home-header_wrapper__Ui-sF","right":"home-header_right__IBm4b","lang":"home-header_lang__WWGdU","btn":"home-header_btn__e3ITw"};